<template>
  <div>
    <div v-if="!template" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <b-jumbotron>
        <b-container>
          <b-row>
            <b-col>
              <div
                v-router-link="{
                  name: 'device-detail',
                  params: { id: template.device_id },
                }"
              >
                {{ template.device_name }}
              </div>
              <h1>{{ template.name }}</h1>
              <h5>Template #{{ template.id }}</h5>
            </b-col>
            <b-col class="text-right">
              <b-button
                variant="primary"
                v-router-link="{
                  name: 'template-editor',
                  query: { id: template.id },
                }"
                :disabled="template.autoverified == 1"
              >
                <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit
                Template
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-jumbotron>
      <b-container>
        <b-tabs>
          <!--profileTab-->
          <b-tab title="Profile" class="mt-3">
            <b-card-group columns>
              <!--description-->
              <b-card no-body>
                <b-card-header>
                  Metadata
                </b-card-header>
                <b-table-simple>
                  <b-tr>
                    <b-td>Created</b-td>
                    <b-td class="text-right pl-5">
                      {{ template.created | moment('YYYY-MM-DD HH:mm') }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Updated</b-td>
                    <b-td class="text-right">
                      {{ template.updated | moment('YYYY-MM-DD HH:mm') }}
                    </b-td>
                  </b-tr>
                </b-table-simple>
              </b-card>
              <!--SVG-->
              <b-card no-body>
                <b-card-header>
                  SVG
                </b-card-header>
                <svg-image
                  :src="`https://cdn.gokaizen.com/${template.svg}`"
                ></svg-image>
                <!-- <img
                  style="max-width:100%;"
                  :src="'https://cdn.gokaizen.com/' + template.svg"
                  class="p-5"
                /> -->
                <b-table-simple>
                  <b-tr>
                    <b-td>Width</b-td>
                    <b-td class="text-right">
                      {{ template.width }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Height</b-td>
                    <b-td class="text-right">
                      {{ template.height }}
                    </b-td>
                  </b-tr>
                </b-table-simple>
                <div class="p-3">
                  <a
                    class="btn btn-outline-primary btn-block"
                    target="_blank"
                    :href="'https://cdn.gokaizen.com/' + template.svg"
                    download
                    >Download</a
                  >
                </div>
              </b-card>
              <!--settings-->
              <b-card no-body>
                <b-card-header>
                  Settings
                </b-card-header>
                <b-table-simple>
                  <b-tr>
                    <b-td>Categories</b-td>
                    <b-td class="text-right">
                      <div v-if="template.typenormal">
                        Normal
                      </div>
                      <div v-if="template.typemagic">
                        Magic
                      </div>
                      <div v-if="template.typeair">
                        Air
                      </div>
                      <div v-if="template.typebody">
                        Body
                      </div>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Easy Install</b-td>
                    <b-td class="text-right">
                      {{ template.easyinstall ? 'Yes' : 'No' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Cut Only</b-td>
                    <b-td class="text-right">
                      {{ template.cutonly ? 'Yes' : 'No' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Hidden</b-td>
                    <b-td class="text-right">
                      {{ template.hidden ? 'Yes' : 'No' }}
                    </b-td>
                  </b-tr>
                </b-table-simple>
              </b-card>
              <b-card no-body>
                <b-card-header>
                  Cutting Instructions
                </b-card-header>
                <b-alert
                  variant="danger"
                  v-if="template.autoverified == 1"
                  class="m-1"
                  show
                >
                  WARNING: This template is currently being converted, and
                  should not be tested or used. Please refresh in a few moments.
                </b-alert>
                <b-alert
                  variant="danger"
                  v-if="template.autoverified == 0"
                  class="m-1"
                  show
                >
                  WARNING: This template has a problem and has failed to
                  convert. Please upload again, or try a different SVG.
                </b-alert>
                <gpgl-viewer
                  :src="template.gpgl"
                  v-if="template.autoverified == 2"
                />
                <div class="p-3">
                  <a
                    v-if="template.hpgl"
                    target="_blank"
                    class="btn btn-outline-primary btn-block"
                    :href="'https://cdn.gokaizen.com/' + template.hpgl"
                    download
                    >Download HPGL</a
                  >
                  <a
                    v-if="template.gpgl"
                    target="_blank"
                    class="btn btn-outline-primary btn-block"
                    :href="'https://cdn.gokaizen.com/' + template.gpgl"
                    download
                    >Download GPGL</a
                  >
                </div>
              </b-card>
            </b-card-group>
          </b-tab>

          <!--archiveTab -->
          <b-tab class="tab-pane fade mt-3">
            <template v-slot:title> Archives ({{ archives.length }}) </template>
            <b-table-simple>
              <b-thead>
                <b-tr>
                  <b-th>Device ID</b-th>
                  <b-th>Type ID</b-th>
                  <b-th>Name</b-th>
                  <b-th>Assets</b-th>
                  <b-th>Created</b-th>
                  <b-th>Updated</b-th>
                  <b-th>Attributes</b-th>
                  <b-th>SVG Width</b-th>
                  <b-th>SVG Height</b-th>
                  <b-th>Types</b-th>
                  <b-th>HPGL Width</b-th>
                  <b-th>HPGL Height</b-th>
                  <b-th>Modified By</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="archive in archives" :key="archive.id">
                  <b-td>{{ archive.id }}</b-td>
                  <b-td>{{ archive.type_id }}</b-td>
                  <b-td>{{ archive.name }}</b-td>
                  <b-td>
                    <div>
                      <a :href="'https://cdn.gokaizen.com/' + archive.svg"
                        >SVG</a
                      >
                    </div>
                    <div>
                      <a :href="'https://cdn.gokaizen.com/' + archive.hpgl"
                        >HPGL</a
                      >
                    </div>
                    <div>
                      <a :href="'https://cdn.gokaizen.com/' + archive.gpgl"
                        >GPGL</a
                      >
                    </div>
                  </b-td>
                  <b-td>{{
                    archive.created | moment('YYYY-MM-DD HH:mm')
                  }}</b-td>
                  <b-td>{{
                    archive.updated | moment('YYYY-MM-DD HH:mm')
                  }}</b-td>
                  <b-td>
                    <div>{{ archive.hidden ? 'Hidden' : 'Visible' }}</div>
                    <div>
                      {{ archive.cutonly ? 'Cut Only' : 'Print & Cut' }}
                    </div>
                  </b-td>
                  <b-td>{{ archive.width }}</b-td>
                  <b-td>{{ archive.height }}</b-td>
                  <b-td>
                    <div v-if="archive.easyinstall">
                      Easy Install
                    </div>
                    <div v-if="archive.typenormal">
                      Normal
                    </div>
                    <div v-if="archive.typemagic">
                      Magic
                    </div>
                    <div v-if="archive.typeair">
                      Air
                    </div>
                    <div v-if="archive.typebody">
                      Body
                    </div>
                  </b-td>
                  <b-td>{{ archive.hpgl_width }}</b-td>
                  <b-td>{{ archive.hpgl_height }}</b-td>
                  <b-td>{{ archive.modifiedby }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-tab>
        </b-tabs>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import GpglViewer from '@/components/GpglViewer';

export default {
  components: {
    GpglViewer,
  },

  data() {
    return {
      query: null,
      template: null,
      archives: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      const templateId = this.$route.params.id;

      $api.get(`/v1/internal/templates/${templateId}`).then((template) => {
        this.template = template;
      });

      $api
        .get(`/v1/internal/templates/${templateId}/archives`)
        .then((archives) => {
          this.archives = archives;
        });
    },
  },
};
</script>
